/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_User_AboveInputs */

const en_select_user_above = /** @type {(inputs: Select_User_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a user above`)
};

const es_select_user_above = /** @type {(inputs: Select_User_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un usuario arriba`)
};

/**
* | output |
* | --- |
* | "Select a user above" |
*
* @param {Select_User_AboveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_user_above = /** @type {((inputs?: Select_User_AboveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_User_AboveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_user_above(inputs)
	return es_select_user_above(inputs)
});